import { render } from "./AddFileToTemplate.vue?vue&type=template&id=7dc0fe5e"
import script from "./AddFileToTemplate.vue?vue&type=script&lang=js"
export * from "./AddFileToTemplate.vue?vue&type=script&lang=js"

import "./AddFileToTemplate.vue?vue&type=style&index=0&id=7dc0fe5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__